


import React from 'react'
import Header from '../inc/Header'
import { Link } from "react-router-dom";
import water from "../images/Water Treetment photo.jpg";
import watertreet from "../images/WATER TREET.jpg";
import watertreetmentpage from "../images/Water t.jpg";

import watertreetment from "../images/Water a2z.jpg";
import waterservices from "../images/Water a2z services.jpg";
import waterpurify from "../images/water purify.jpg";


function Waterpage() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />

      <div className='exteriordesign'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Water Treatment</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="album py-2">
        <div className="container " >
          <div className="row ">
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={watertreet} className="card-img-top" alt="watertreet"/>
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment
                  </h5>
                  <p className="card-text"><small>We use only industry-approved and environmentally compliant systems.</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={watertreetmentpage} className="card-img-top" alt="watertreetmentpage"/>
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment</h5>
                  <p className="card-text"><small>Designed specifically for your water quality, usage, and compliance</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={water} className="card-img-top" alt="a2zindia" />
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment
                  </h5>
                  <p className="card-text"><small>Designed specifically for your water quality, usage, and compliance</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>

             <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={watertreetment} className="card-img-top" alt="watertreetment"/>
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment
                  </h5>
                  <p className="card-text"><small>We use only industry-approved and environmentally compliant systems.</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>

             <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={waterservices} className="card-img-top" alt="a2zindia"/>
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment
                  </h5>
                  <p className="card-text"><small>We use only industry-approved and environmentally compliant systems.</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>
             <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={waterpurify} className="card-img-top" alt="a2zindia"/>
                <div className="card-body">
                  <h5 className="card-title">Commercial Water Treatment
                  </h5>
                  <p className="card-text"><small>We use only industry-approved and environmentally compliant systems.</small></p>
                  <a style={{ color: "white" }} href="tel: 9732000307" className="callbutton">Call Now</a>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <br />
    </div>
  )
}

export default Waterpage